"use strict";
/*
    Create By CC 2015-12-12
*/
/*
    功能：替换通用的分页左侧显示
    使用方法：<trs-pagenation-left pageCount="xxx" callback="xxx" newPagesize="xxx" isSelectPagecount="xxxx"></trs-pagenation-left>
    pageCount:传入值为父控制器的分页参数，用于展示
    callback:父控制器的回掉函数
    isSelectPagecount:是否开启选择分页数功能
 */
angular.module('trsPagenationConfigLeftModule', []).
directive('trsPagenationLeft', ["$filter", "$timeout", function($filter, $timeout) {
    return {
        restrict: 'EA',
        template: ['<p ng-hide="hide">',
            '  共',
            '  <span ng-bind="pageCount.ITEMCOUNT"></span>',
            '  <span>条数据</span> 单页显示',
            '  <trs-single-select  selected-option="selectOption" callback="queryByPageSize()" options="pageCountJsons" ng-show="isSelectPagecount"></trs-single-select>',
            '  <span ng-bind="pageCount.PAGESIZE " ng-show="!isSelectPagecount"></span>',
            '</p>'
        ].join(""),
        scope: {
            pageCount: "=",
            /*分页对象 包括单页显示 总页数 当前页和总条数*/
            callback: "&",
            isSelectPagecount: "=",
        },
        link: function(scope, iElement, iAttrs) {
            if (angular.isUndefined(scope.pageCount)) {
                scope.pageCount = {
                    'ITEMCOUNT': 0,
                    "PAGESIZE": 12,
                };
            }
            scope.$watch('pageCount.ITEMCOUNT', function(newV, oldV) {
                scope.hide = newV < 12 ? true : false;
            });
            if (scope.isSelectPagecount) {
                scope.pageCountJsons = [{ "name": "12", "value": 12 }, { "name": "50", "value": 50 }, { "name": "100", "value": 100 }];
                dealOptions();
                scope.selectOption = {
                    name: scope.pageCount.PAGESIZE,
                    value: scope.pageCount.PAGESIZE
                };
                scope.queryByPageSize = function() {
                    $timeout(function() {
                        scope.pageCount.CURRPAGE = "1";
                        scope.pageCount.PAGESIZE = scope.selectOption.value;
                        scope.callback();
                    });
                };
            }
            //处理可选项
            //初始化的选项不包含在前端写死的默认选项里，所有要在这里事先加进去
            function dealOptions() {
                var initSelection = {
                    name: scope.pageCount.PAGESIZE,
                    value: scope.pageCount.PAGESIZE
                };
                var flag = true;
                for (var i = 0; i < scope.pageCountJsons.length; i++) {
                    if (parseInt(scope.pageCountJsons[i].value) === parseInt(initSelection.value)) {
                        flag = false;
                    }
                }
                if (flag) {
                    scope.pageCountJsons.push(initSelection);
                    scope.pageCountJsons.sort(function(a, b) {
                        return parseInt(a.value) - parseInt(b.value);
                    });
                }
            }
        }
    };
}]);